module.exports = __webpack_public_path__ + "static/home-artist-marketing-mobile-9cac2a98fe5b68a7d8ad1a5701599d09.webp";